export const isDevBox = (): boolean => process.env.REACT_APP_IS_DEV_BOX === 'true';
export const isDevEnvironment = (): boolean => process.env.REACT_APP_ENV === 'development';
export const isTestEnvironment = (): boolean => process.env.REACT_APP_ENV === 'test';
export const isStagingEnvironment = (): boolean => process.env.REACT_APP_ENV === 'staging';
export const isProdEnvironment = (): boolean => process.env.REACT_APP_ENV === 'production';

/**
 * Previews build with `REACT_APP_ENV=staging`, so they are deliberately
 * indistinguishable from staging everywhere that matters. This is the one
 * exception: it exists to expose dev-only debug affordances on a preview host,
 * and must never be used to change app behaviour.
 */
export const isPreviewEnvironment = (frontEndUrl = process.env.REACT_APP_FRONT_END_URL): boolean =>
  /^https:\/\/preview-[a-e]\.shef\.com$/.test(frontEndUrl ?? '');
export const getEnvironment = (): string => process.env.REACT_APP_ENV || 'development';
